import { render, staticRenderFns } from "./applyForm.vue?vue&type=template&id=52ac010f&scoped=true"
import script from "./applyForm.vue?vue&type=script&lang=ts"
export * from "./applyForm.vue?vue&type=script&lang=ts"
import style0 from "./applyForm.vue?vue&type=style&index=0&id=52ac010f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac010f",
  null
  
)

export default component.exports